import { render } from "./header1.vue?vue&type=template&id=6f8cf490"
import script from "./header1.vue?vue&type=script&lang=js"
export * from "./header1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__